/**
 * Whether Google Places calls should be answered by the canned E2E mock
 * instead of the real API.
 *
 * Two switches turn it on:
 * - `VITE_ENV === 'e2e'` — the CI build.
 * - `window.__MOVEPRO_E2E__ === true` — set by the Playwright fixture in
 *   `tests/helpers/test-fixtures.ts`, so a local run against the everyday
 *   dev server (`VITE_ENV=local`, real key present) is mocked too.
 *
 * The key is deliberately not part of the check: a key in a developer's
 * `.env` used to switch the mock off and let E2E runs bill Google.
 *
 * Read at call time, not at module load, so the flag is honoured whenever
 * the init script runs.
 *
 * @returns {boolean}
 */
export default function usesGooglePlacesE2eMock() {
    return import.meta.env.VITE_ENV === 'e2e' || window.__MOVEPRO_E2E__ === true;
}
